import { useEffect, useState } from "react";
import { _EmployeeContract, _EmployeeContractHistory, _single } from "../../../../core/services/dataBean/EntityCatalog";
import useDataBean from "../../../../core/services/dataBean/useDataBean";
import { Singleton } from "../../../../core/services/Singleton";
import { BasicPage } from "../../../theme/Component/BasicPage";
import { BasicTable, MASK_DATE, MASK_MONEY, MASK_NUMBER, MASK_TEXT_NOWRAP } from "../../../theme/Component/BasicTable";
import { BasicButton } from "../../../theme/Component/BasicButton";
import usePaginator from "../../../theme/Component/usePaginator";
import { ListMenu } from "../../../theme/Component/ListMenu";
import { Modal } from "../../../theme/Component/Modal";
import { _EmployeeFactorsConsolidated, _FunctionalAreaToEmployee } from "../../../../core/services/dataBean/EntityCatalogVdos";
import { toast } from "react-toastify";
import { InputDate } from "../../../theme/Input/InputDate";
import { SelectFunctionalArea } from "../../../admin/configuracion/FunctionalArea/SelectFunctionalArea";
import { YearSelector } from "../../../../core/shared/inputs/YearSelector";
import { AccountEditor } from "../../../editor/AccountEditor";
import { ValueTypeSelector } from "../../../Talentohumano/ParametrosTalentoHumano/ImportedPayrollConcept/EditorsySelectors/ValueType.Selector";
import { FortnightTypeConstants } from "../../../Talentohumano/ParametrosTalentoHumano/PayrollFactor/FortnightTypeConstants";
import { AppointmentEditor } from "../../../Talentohumano/ParametrosTalentoHumano/Appointment/Appointment.editor";
import { EntailmentEditor } from "../../../Talentohumano/ParametrosTalentoHumano/Entailment/Entailment.editor";
import { PayrollFactorNameList } from "../../../admin/configuracion/EmployeeFactorsConsolidated/PayrollFactorNameList";
import { EmploymentTypeEditor } from "./ComponentsContract/EditorsEmployeContrac/EmploymentType.editor";
import { SelectFunctionalID } from "../../../admin/configuracion/functionalID/SelectFunctionalID";
import { SelectSiteID } from "../../../admin/configuracion/SiteID/SelectSiteID";

export const EmployeeContractsWithDefeat = () => {

    const employeecontractdefeat = useDataBean(_EmployeeContract);
    // const employeeContracttofunctional = useDataBean(_FunctionalAreaToEmployee);
    const single = Singleton.getInstance();
    const [lista, setLista] = useState<any>([]);
    const [date, setdate] = useState<any>(_single.getCurrenDate());
    const [Account, setAccount] = useState<any>(null);
    const [employetype, setemployetype] = useState<any>(null);
    const [functional, setFuntional] = useState<any>(null);
    const [IDLnSiteID, setIDLnSiteID] = useState<any>(null);
    const [regexStr, setregexStr] = useState<any>(null);
    const [defeatDays, setdefeatDays] = useState<any>(15);
    const [Fornight, setFornight] = useState<any>(null);
    const [NameList, setNamelist] = useState<any>(null);
    const [Appointment, setAppointment] = useState<any>(null);
    const [EntailmentName, setEntailmentName] = useState<any>(null);
    const [records, setRecords] = useState<number>(15);
    const [modaldefinirplaza, setModaldefinirplaza] = useState<any>({ tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-lg' });
    const paginador = usePaginator();

    useEffect(() => {
        getLista();
    }, [paginador.page])

    const getLista = () => {
        employeecontractdefeat.instance.getEmployeeContractsWithDefeatDates(defeatDays, Account, date, employetype, functional, EntailmentName, Appointment, IDLnSiteID, regexStr, paginador.page, 15).then(
            (resp) => {
                //console.log(resp.NumberOfPages)
                paginador.setPages(resp.NumberOfPages);
                paginador.setRecords(resp.NumberOfPages * (15));
                paginador.setRegiPerPage(15)

                setLista(resp.List)
            }
        )
    }

    const head = [
        { title: 'IDContrato', property: 'IDContract', visible: true, mask: MASK_NUMBER },
        { title: 'Usuario', property: 'AccountName', visible: true, mask: MASK_TEXT_NOWRAP },
        { title: 'Perfil de Liquidación', property: 'IDEmployeeLiquidate', visible: true },
        { title: 'Nivel Jerárquico', property: 'EntailmentName', visible: true },
        { title: 'Nivel Salarial/Grado', property: 'AppointmentName', visible: true },
        { title: 'Tipo Vinculación', property: 'ContractTypeName', visible: true },
        { title: 'Plaza Laboral', property: 'IDLnFu nctionalArea', mask: MASK_NUMBER, visible: true },
        { title: 'Fecha de Inicio', property: 'InitContract', mask: MASK_DATE, visible: true },
        { title: 'Ingreso Nación', property: 'NationInit', mask: MASK_DATE, visible: true },
        // { title: 'Utilizar Tipo de Payroll', property: 'UsePayrollType', visible: true },
        // { title: 'Tipo de Payrol', property: 'PayrollTypeName', visible: true },
        { title: 'Centro de Costo', property: 'CostingCenterName', visible: true },
        { title: 'Unidad de Negocio', property: 'BusinessCoreCode', visible: true },
        { title: 'Tipo de Payroll', property: 'PayrollTypeName', visible: true },
        { title: 'EPS', property: 'EPSName', visible: true },
        { title: 'ARP', property: 'ARPName', visible: true },
        { title: 'CCF', property: 'CCFName', visible: true },
        { title: 'Fondo Pensional', property: 'FPName', visible: true },
        { title: 'Fondo Cesantías', property: 'FCEName', visible: true },
        { title: 'Tipo de Salario', property: 'RevenueType', visible: true },
        { title: 'Salario', property: 'Revenue', mask: MASK_MONEY, visible: true },
        { title: 'Usar Salario Definido en el Contrato', property: 'UseContractSalaryValue', visible: true },
        { title: 'Salario Definido por Contrato', property: 'ContractSalaryValue', mask: MASK_MONEY, visible: true },
        { title: 'Tipo Riesgo', property: 'ARPRiskName', visible: true },
        { title: 'Tipo Cotizante', property: 'EmployeeTypeName', visible: true },
        { title: 'Subtipo Cotizante', property: 'EmployeeSubtypeName', visible: true },
        { title: 'Fecha Renuncia', property: 'EndingDate', mask: MASK_DATE, visible: true },
        { title: 'Estado', property: 'ContractStateName', visible: true },
        { title: 'Fecha Liquidación', property: 'UptoContract', mask: MASK_DATE, visible: true },
        { title: 'Fecha de Nacimiento', property: 'BornDate', mask: MASK_DATE, visible: true },
        { title: 'Dirección', property: 'Address', mask: MASK_TEXT_NOWRAP, visible: true },
        { title: 'Teléfono', property: 'Tel', visible: true },
        { title: 'Correo Electrónico', property: 'eMail', visible: true },
        { title: 'Género', property: 'GenType', visible: true },
        { title: 'Resposable ImpoRenta', property: 'RentTax', visible: true },
        { title: 'Último Exámen Médico', property: 'HealthTestDate', mask: MASK_DATE, visible: true },
        { title: 'Últimas Vacaciones', property: 'LastVacDate', mask: MASK_DATE, visible: true },
        { title: 'Última Dotación', property: 'LastEndowmentDate', mask: MASK_DATE, visible: true },
        { title: 'Tipo de Empleo', property: 'EmploymentTypeName', visible: true },
        { title: 'Código CIIU', property: 'CIIUCode', mask: MASK_NUMBER, visible: true },
        { title: 'Subtipo ARL', property: 'ARPRiskName', visible: true },
        { title: 'Tipo de Contrato', property: 'EmployeeContractType', visible: true },
        { title: 'Definir Límite de UVTs', property: 'UseUVTMaxRetefuente', visible: true },
        { title: 'Limite UVTs', property: 'UVTMaxRetefuente', visible: true },
        { title: 'Ciudad de Ejecución del Contrato', property: 'SiteIDName', visible: true },
        { title: 'Creado por', property: 'EmployeeName', visible: true },
        { title: 'Actualizado por', property: 'LastUpdateEmployeeName', visible: true },
        { title: 'Método de Cálculo', property: 'IDTaxRetentionMethodName', visible: true },
        { title: '% Fijo de Retención para el Procedimiento 2', property: 'TaxRetentionPercent2', visible: true },
        { title: 'Última Actualización', property: 'LastUpdate', visible: true, mask: MASK_DATE },
        { title: 'Unidad de Negocio', property: 'BusinessCoreCode', visible: true },
        { title: 'Definir Centro de Costo', property: 'UseOwnCostingCenter', visible: true },
        { title: 'Centro de Costo', property: 'CostingCenterName', visible: true },
        { title: 'Utilizar Tipo de Payroll', property: 'UsePayrollType', visible: true },
        { title: 'Tipo de Payroll', property: 'PayrollTypeName', visible: true },
    ]


    const listaBotones = () => {
        const botones = [

            { titulo: '', icono: 'ri-edit-2-line', visible: single.canDelete(), evento: () => { setModaldefinirplaza({ ...modaldefinirplaza, "view": true }) } },

        ]
        return (
            <ListMenu listaBotones={botones} />
        )
    }

    return (
        <BasicPage titulo="Alertas Vencimientos Fechas en Contratos Laborales">

            <div className="row">
                <div className="col-md-4">
                    <InputDate name="DateEC" label="Fecha de Corte" value={date} setDate={(e: any) => { setdate(e) }} />
                </div>
                <div className="col-md-4">
                    <label>Dias de Vencimiento</label>
                    <input type="text" className="form-control" value={defeatDays} onChange={(e) => { setdefeatDays(e.target.value) }} />
                </div>
                <div className="col-md-4">
                    <AccountEditor idAccount={Account} onChange={(e) => { setAccount(e) }} label="Empleado" />
                </div>

                <div className="col-md-4">
                    <EmploymentTypeEditor idSelector={employetype} onChange={(e: any) => { setemployetype(e) }} />
                </div>
                <div className="col-md-4">
                    <SelectFunctionalID label="Unidad Organizacional" onChange={(e) => { setFuntional(e?.IDLn) }} />
                </div>
                <div className="col-md-4">
                    <AppointmentEditor label="Nivel Salarial" idSelector={Appointment} onChange={(e) => { setAppointment(e) }} />
                </div>
                <div className="col-md-4">
                    <EntailmentEditor label="Nivel Jerárquico" idSelector={EntailmentName} onChange={(e) => { setEntailmentName(e) }} />
                </div>
                <div className="col-md-4">
                    <SelectSiteID edit idLnSite={IDLnSiteID} label="Ubicación Geográfica" onChange={(e) => { setIDLnSiteID(e.IDLn) }} />
                </div>
                <div className="col-md-4">
                    <label>Búsqueda por Texto</label>
                    <input type="text" className="form-control" value={regexStr} onChange={(e) => { setregexStr(e.target.value) }} />
                </div>
                <div className="col-md-4 mt-4">
                    <BasicButton icon="ri-search-line" eventClick={getLista}>Buscar</BasicButton>
                </div>
                <div className="col-md-12">
                    <BasicTable
                        head={head}
                        body={lista}
                        rowSet={employeecontractdefeat.setBean}
                        pageTop={paginador.page}
                        next={paginador.next}
                        back={paginador.back}
                        records={paginador}
                        customRows={records}
                    />
                </div>
            </div>

        </BasicPage>
    )
}